export const modalImportClients = {
	feedback: {
		verifyBaseSheet:
			", please check the sample spreadsheet template or use it as a base spreadsheet.",
		unidentifiedColum: "Error in column names",
		emptySheet: "This sheet is empty",
		emptyHeaderCell: "Columns missing name",
		sheetPoorlyFormatted:
			"Format spreadsheet for Calibri font, size 11, remove spaces, unnecessary line breaks and bold",
		default: "An error occurred while importing the sheet",
		errorMessage: "Invalid worksheet, download it again and make necessary changes.",
		download: "Download",
	},
	clients: "Clients",
	import: "Import customers",
	invalidClientList: "Client List (invalid)",
	importSheet: "Import Sheet",
	downloadSheet: "Download sample sheet",
	name: "Name",
	cpf: "CPF",
	phone: "Phone",
	addedClient: "client added",
	addedClients: "added clients",
	emptyMessage: {
		title: "No customers added",
		description:
			"Add customers by CPF or by importing a list of CPFs from the example worksheet.",
	},
	add: "Add customers",
};
